import { request } from '@ltvco/refresh-lib/utils';

const locationURL = '/api/v5/subscription/reactivate_with_plan_change';

const reactivateWithPlanChange = async (planId: number) => {
  const init = {
    body: JSON.stringify({
      plan_id: planId,
    }),
    headers: {
      'content-type': 'application/json',
    },
    method: 'POST',
  };

  return await request(`${locationURL}`, init);
};

export default reactivateWithPlanChange;
